import React, { useEffect, useState } from "react";
import chevronLeft from "../../assets/svg/backArrow.svg";
import transactionLogo from "../../assets/svg/transactionLogo.svg";
import deleteLogo from "../../assets/svg/payment-history-delete.svg";
import locationIc from "../../assets/svg/location.svg";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import chevronDown from "../../assets/svg/dropDown.svg";
import threeDots from "../../assets/svg/threeDotMenu.svg";
import brush from "../../assets/svg/brush.svg";
import editIcon from "../../assets/svg/edit_ic.svg";
import card from "../../assets/svg/creditCard.svg";
import "../common/Util.css";
import pdf from "../../assets/svg/pdf.svg";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import downloadIc from "../../assets/svg/download_Ics.svg";
import attachmentIC from "../../assets/png/attachment.png";
import { deleteTransApi, deleteHistoryApi, getTransactionApi, updateStageApi, getEditHistoryApi } from "./transaction_api";
import LoaderModal from "../common/loader";
import DeleteModal from "../common/deleteModel";
import profileIc from "../../assets/png/profile-ic.png";
import PaymentUpdateModal from "./payment-update";
import addPayment from "../../assets/svg/add-payment.svg";
import { getVendorAddress } from "../purchase-quotation/pq-api";
import numberFormat from "../common/number-format";
import ProfileImageModal from "../common/common-preview";
import AmountSummary from "../common/AmountSummary";
import tickGreen from "../../assets/svg/tick_green.svg";
import wrongRed from "../../assets/svg/wrong_red.svg";
import requestImg from "../../assets/svg/request_img.svg";
import createdImg from "../../assets/svg/created_img.svg";
import { apiCall } from "../../services/api-service.js";
export const TransactionView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const openFile = (fileUrl = "") => {
    if (!fileUrl) return;

    const cleanUrl = fileUrl.split("?")[0].toLowerCase();

    // 🖼 Images → popup
    if (cleanUrl.endsWith(".png") || cleanUrl.endsWith(".jpg") || cleanUrl.endsWith(".jpeg") || cleanUrl.endsWith(".gif") || cleanUrl.endsWith(".webp")) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📄 PDF → open directly in browser
    if (cleanUrl.endsWith(".pdf")) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📊 Office files → Office Viewer
    if (cleanUrl.endsWith(".xls") || cleanUrl.endsWith(".xlsx") || cleanUrl.endsWith(".doc") || cleanUrl.endsWith(".docx") || cleanUrl.endsWith(".ppt") || cleanUrl.endsWith(".pptx")) {
      const officeViewerUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(fileUrl);

      window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // ⬇ Default → download / open
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const { id } = location.state || {};
  const [transactionDetails, setTransactionDetails] = useState({});
  const [stageListOption, setListStageOption] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [historyDeleteId, setHistoryDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenHistoryDelete, setIsOpenHistoryDelete] = useState(false);
  const [paidHistory, setPaidHistory] = useState([]);
  const [editHistory, setEditHistory] = useState([]);
  const [activeHistoryTab, setActiveHistoryTab] = useState("paid");
  const [isShowPaymentUpdate, setIsShowPaymentUpdate] = useState(false);
  const [isEditHistoryLoading, setIsEditHistoryLoading] = useState(false);
  const [isEligibleApprover, setIsEligibleApprover] = useState(false);
  const [approvalHistory, setApprovalHistory] = useState([]);
  const [canReject, setCanReject] = useState(false);
  const [commentsMandatory, setCommentsMandatory] = useState(false);

  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");
  const [approvalComments, setApprovalComments] = useState("");
  const [approvalCommentsMandatory, setApprovalCommentsMandatory] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  useEffect(() => {
    if (id != null && id !== undefined) {
      getTransactionDetails();
    }
  }, [id]);
  const [isIgst, setIsIgst] = useState(false);
  const [isCgst, setIsCgst] = useState(false);
  const [isSgst, setIsSgst] = useState(false);
  const getAddress = async (id) => {
    try {
      const response = await getVendorAddress(id);
      if (response.data.success === true) {
        setIsIgst(response.data.data.igst ?? false);
        setIsCgst(response.data.data.cgst ?? false);
        setIsSgst(response.data.data.sgst ?? false);
      }
    } catch (e) {}
  };
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  useEffect(() => {
    if (historyDeleteId !== null) {
      setIsOpenHistoryDelete(true);
    }
  }, [historyDeleteId]);

  const getTransactionDetails = async () => {
    try {
      const response = await getTransactionApi(id);
      console.log("response....", response);
      if (response.data.success === true) {
        setTransactionDetails(response.data.transaction ?? {});
        getAddress(response.data.transaction.vendor_id);
        setPaidHistory(response.data.transaction?.history ?? []);
        if (response.data.transaction?.approval_config_id) {
          fetchApprovalHistory(response.data.transaction.id);
        } else {
          setIsEligibleApprover(false);
          setCanReject(false);
          setApprovalHistory([]);
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const fetchApprovalHistory = async (docId) => {
    try {
      const response = await apiCall("get", `approval_history/${docId}`, null, {
        params: { type: "transaction" }
      });
      if (response.data?.success) {
        const historyList = response.data.histories ?? [];
        setApprovalHistory(historyList);
        const isEligible = response.data.is_eligible ?? false;
        setIsEligibleApprover(isEligible);
        setCanReject(response.data.can_reject ?? false);
        setCommentsMandatory(response.data.comments_mandatory ?? false);
      }
    } catch (e) {
      console.error("Error fetching approval history", e);
    }
  };

  const handleApprovalActionClick = (action) => {
    if (action === "REJECT" && !canReject) {
      alert("Reject action is not allowed for this level.");
      return;
    }
    setApprovalAction(action);
    setApprovalComments("");
    setApprovalCommentsMandatory(commentsMandatory || action === "REJECT");
    setShowApprovalModal(true);
  };

  const handleApprovalAction = async () => {
    if (approvalCommentsMandatory && !approvalComments.trim()) {
      alert("Comment is required.");
      return;
    }

    setShowApprovalModal(false);
    try {
      const response = await apiCall("post", "approval/action", {
        document_id: id,
        document_type: "transaction",
        action: approvalAction,
        comments: approvalComments
      });
      if (response.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getTransactionDetails();
        fetchApprovalHistory(id);
      } else {
        setSnackbarMessage(response.data?.message || "Action failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (e) {
      console.error(e);
      setSnackbarMessage("An error occurred.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };

  const fetchEditHistory = async () => {
    setIsEditHistoryLoading(true);
    try {
      const response = await getEditHistoryApi(id);
      if (response?.data?.success === true) {
        setEditHistory(response.data.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching edit history:", err);
    } finally {
      setIsEditHistoryLoading(false);
    }
  };
  const updateStage = async (value) => {
    // setIsLoading(true);
    const bodyData = {
      stage: value,
    };
    try {
      const response = await updateStageApi(id, bodyData);
      console.log("response....", response);
      if (response.data.success === true) {
        getTransactionDetails();
        // setSnackbarMessage(response.data.message);
        // setSnackbarStatus(response.data.success);
        // handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      // setIsLoading(false);
    }
  };
  const deleteTrans = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteTransApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getTransactionDetails();
        // setSnackbarMessage(response.data.message);
        // setSnackbarStatus(response.data.success);
        // handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
        navigator(-1);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      // setIsLoading(false);
    }
  };
  const deleteHistory = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteHistoryApi(historyDeleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getTransactionDetails();
        // setSnackbarMessage(response.data.message);
        // setSnackbarStatus(response.data.success);
        // handleSnackbarShow();
        setHistoryDeleteId(null);
        setIsOpenHistoryDelete(false);
        navigator(-1);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      // setIsLoading(false);
    }
  };
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };
  function onSuccessStatus() {
    setIsShowPaymentUpdate(false);
    setSnackbarMessage("Bulk status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getTransactionDetails();
  }
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");

  const toNumber = (v) => {
    if (v === null || v === undefined) return 0;
    const cleaned = String(v).replace(/,/g, "").trim();
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
  };

  const calculateSummary = (txn) => {
    let subTotal = 0;
    let cgstTotal = 0;
    let sgstTotal = 0;
    let igstTotal = 0;

    txn.products?.forEach((row) => {
      const unitPrice = toNumber(row.unit_amount);

      const base = toNumber(row.quantity) * unitPrice;

      subTotal += base;
      cgstTotal += base * (toNumber(row.cgst_percentage) / 100);
      sgstTotal += base * (toNumber(row.sgst_percentage) / 100);
      igstTotal += base * (toNumber(row.igst_percentage) / 100);
    });

    const grossTotal = subTotal + cgstTotal + sgstTotal + igstTotal;
    const roundDiff = toNumber(txn.round_diff);

    return {
      subTotal,
      cgstTotal,
      sgstTotal,
      igstTotal,
      roundDiff,
      finalTotal: grossTotal + roundDiff,
    };
  };

  const summary = calculateSummary(transactionDetails);

  return (
    <>
      <ProfileImageModal show={showProfilePopup} onClose={() => setShowProfilePopup(false)} imageUrl={selectedProfile} /> {/* <LoaderModal show={isLoading} /> */}
      <DeleteModal title={"transaction"} isOpen={isOpenDelete} onClose={() => setIsOpenDelete(false)} onDelete={deleteTrans} />
      <DeleteModal title={"payment"} isOpen={isOpenHistoryDelete} onClose={() => setIsOpenHistoryDelete(false)} onDelete={deleteHistory} />
      <Modal
        show={showApprovalModal}
        onHide={() => setShowApprovalModal(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-18 fw-600 textcolor">
            {approvalAction === "REJECT" ? "Reject Transaction" : "Approve Transaction"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <Form.Group>
            <Form.Label className="fs-14 fw-500 textcolor mb-2">
              {approvalAction === "REJECT"
                ? "Enter reason for rejection"
                : "Enter comments"
              }
              {approvalCommentsMandatory && <span className="text-danger"> *</span>}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={approvalComments}
              onChange={(e) => setApprovalComments(e.target.value)}
              placeholder="Type comments here..."
              className="fs-13 rounded-3"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setShowApprovalModal(false)}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
          >
            Cancel
          </Button>
          <Button
            variant={approvalAction === "REJECT" ? "danger" : "primary"}
            onClick={handleApprovalAction}
            disabled={approvalCommentsMandatory && !approvalComments.trim()}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
            style={approvalAction !== "REJECT" ? { backgroundColor: "#2563EB", borderColor: "#2563EB" } : {}}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {isShowPaymentUpdate && (
        <PaymentUpdateModal
          id={id}
          success={onSuccessStatus}
          onHide={() => {
            setIsShowPaymentUpdate(false);
          }}
        />
      )}
      <div className="d-flex">
        <Sidebar currentfile="Transactions" />
        <div className="flex-grow-1">
          <div className="bg-half-white">
            {" "}
            <Navbar pageTitle="Transactions" />
            <div className="d-flex flex-wrap justify-content-between align-items-center bg-white p-3">
              <div className="d-flex align-items-center gap-3">
                <img
                  src={chevronLeft}
                  className="cursor-pointer btnBorder rounded-circle p-3"
                  alt="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                <div className="profile-wrapper">
                  <img
                    src={transactionDetails.image && transactionDetails.image.trim() !== "" ? transactionDetails.image : profileIc}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      openFile(transactionDetails.image && transactionDetails.image.trim() !== "" ? transactionDetails.image : profileIc);
                    }}
                    alt="Profile"
                    className="profile-img"
                  />
                  <div className="profile-badge fs-11">{transactionDetails.grade_name ?? "-"}</div>
                </div>
                <div className="d-flex flex-column">
                  <p className=" fs-16 fw-400 textPurple">{transactionDetails.vendor ?? "-"}</p>
                  <div className="d-flex align-items-center gap-1">
                    <img src={locationIc} alt="location" />
                    <p className="m-0 fs-12 fw-400 textGrey">{transactionDetails.location ?? "-"}</p>
                    <div className="backgroundGreyDot" style={{ width: "4px", height: "4px" }}></div>
                    <p className="m-0 fs-12 fw-500 backgroundBlue textBlue rounded-pill px-2 py-1">{transactionDetails.industry ?? "-"}</p>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3  w-25">
                {isEligibleApprover && (
                  <div className="d-flex gap-2 align-self-center me-2">
                    <Button
                      variant="success"
                      className="rounded-5 fs-13 fw-600 px-3"
                      style={{ height: "36px", backgroundColor: "#10B981", borderColor: "#10B981" }}
                      onClick={() => handleApprovalActionClick("APPROVE")}
                    >
                      Approve
                    </Button>
                    {canReject && (
                      <Button
                        variant="danger"
                        className="rounded-5 fs-13 fw-600 px-3"
                        style={{ height: "36px", backgroundColor: "#EF4444", borderColor: "#EF4444" }}
                        onClick={() => handleApprovalActionClick("REJECT")}
                      >
                        Reject
                      </Button>
                    )}
                  </div>
                )}
                {(transactionDetails.is_payment && transactionDetails.is_payment !== "false") && (
                  <div
                    style={{
                      padding: "6px 12px",
                      background: "#E9E8FF",
                      cursor: "pointer",
                    }}
                    className="d-flex align-items-center justify-content-between rounded-5"
                    onClick={() => {
                      setIsShowPaymentUpdate(true);
                    }}
                  >
                    <img src={addPayment} alt="add" />
                    <span style={{ color: "#4F46E5" }} className="dropdown-text textcolor fs-13 fw-500">
                      Add Payment
                    </span>
                  </div>
                )}

                <div
                  style={{
                    padding: "6px 12px",
                  }}
                  className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                >
                  {" "}
                  <span className="d-flex align-items-center px-1 gap-2">
                    <span
                      className="backgroundYellow"
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "3px",
                        display: "inline-block",
                      }}
                    ></span>

                    <span className="dropdown-text textcolor fs-13 fw-500">{transactionDetails.status ?? "-"}</span>

                    <span className="dropdown-toggle-arrow">{/* <DownArrowIc /> */}</span>
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white">
              <div className="row w-100 p-3">
                <div className="col-xl-3">
                  <div className="btnBorder d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Transaction amount</p>
                      <p className="m-0 cardTextGreen fs-15 fw-500">+<span dangerouslySetInnerHTML={{ __html: transactionDetails.currency_symbol || "&#8377;" }} /> {numberFormat(transactionDetails.trans_amount ?? "0")}</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 mt-3 mt-xl-0">
                  <div className="btnBorder d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Paid amount</p>
                      <p className="m-0 cardTextBlue fs-15 fw-500">+<span dangerouslySetInnerHTML={{ __html: transactionDetails.currency_symbol || "&#8377;" }} />{numberFormat(transactionDetails.paid_amount ?? 0)}</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 mt-3 mt-xl-0">
                  <div className="btnBorder d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Balance amount</p>
                      <p className="m-0 cardTextRed fs-15 fw-500">+<span dangerouslySetInnerHTML={{ __html: transactionDetails.currency_symbol || "&#8377;" }} />{numberFormat(transactionDetails.balance_amount ?? 0)}</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 mt-3 mt-xl-0">
                  <div className="btnBorder d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Total amount</p>
                      <p className="m-0 fs-15 fw-500">+<span dangerouslySetInnerHTML={{ __html: transactionDetails.currency_symbol || "&#8377;" }} />{numberFormat(transactionDetails.total_amount ?? 0)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row w-100 p-2 bg-half-white">
              <div className="col-xl-7 mt-3">
                <div className="bg-white rounded-4 p-3">
                  <p className="fs-16 fw-600">Transaction details</p>
                  <div className="">
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Transaction ID</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.transaction_id ?? "-"}</span>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Transaction Type</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.trans_type ?? "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">PO No</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.po_no ?? "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Payment Date</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.trans_date ?? "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Payment Type</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <img src={card} alt="icon" className="me-2" style={{ width: "16px", height: "16px" }} />
                        <span className="fs-14 fw-500">{transactionDetails.payment_type ?? "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Project</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.project_name ?? "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Category</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails?.category_name?.trim() ? transactionDetails.category_name : "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Vendor</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.vendor ?? "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Remarks</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails?.remarks?.trim() ? transactionDetails.remarks : "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Updated by</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.user ?? "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-xl-3 col-lg-3 col-7 d-flex align-items-center cardTextGrey fs-14 fw-400">Updated at</div>
                      <div className={`col-7 d-flex align-items-center`}>
                        <span className="fs-14 fw-500">{transactionDetails.date ?? "-"}</span>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <p className="fs-16 fw-600">Attachment</p>
                  {(transactionDetails?.attachments || []).map((file, index) => (
                    <div
                      key={index}
                      className="rounded-4 p-2 d-flex align-items-center w-50 gap-3 my-2"
                      style={{ backgroundColor: "#F8F8F8" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.nativeEvent.stopImmediatePropagation(); // 🔥 THIS is the key

                        e.stopPropagation();

                        openFile(file.file);
                      }}
                    >
                      <img src={attachmentIC} alt="pdf" style={{ width: "32px", height: "32px" }} />
                      <div className="d-flex flex-column">
                        <p className="m-0 fs-13 fw-500">{file?.file_name || "-"}</p>
                      </div>{" "}
                      {file.file && (
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            downloadFile(file.file, file.file.split("/").pop());
                          }}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                          }}
                        >
                          <img
                            src={downloadIc}
                            alt="download"
                            style={{
                              width: "12.8px",
                              height: "12px",
                              top: "10px",
                              left: "9.6px",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-xl-5 mt-3">
                <div className="bg-white rounded-4 p-3">
                  {/* Tab Headers */}
                  <div className="d-flex gap-2 mb-4">
                    <button
                      id="tab-paid-history"
                      className={`btn btn-sm rounded-pill px-3 py-2 fs-13 fw-600 border-0 ${activeHistoryTab === "paid" ? "text-white" : "bg-light text-dark"}`}
                      style={{
                        backgroundColor: activeHistoryTab === "paid" ? "#4F46E5" : undefined,
                        transition: "all 0.25s ease",
                      }}
                      onClick={() => setActiveHistoryTab("paid")}
                    >
                      Paid History
                    </button>
                    <button
                      id="tab-edit-history"
                      className={`btn btn-sm rounded-pill px-3 py-2 fs-13 fw-600 border-0 ${activeHistoryTab === "edit" ? "text-white" : "bg-light text-dark"}`}
                      style={{
                        backgroundColor: activeHistoryTab === "edit" ? "#4F46E5" : undefined,
                        transition: "all 0.25s ease",
                      }}
                      onClick={() => {
                        setActiveHistoryTab("edit");
                        fetchEditHistory();
                      }}
                    >
                      Edit History
                    </button>
                    {transactionDetails.approval_config_id && (
                      <button
                        id="tab-approval-history"
                        className={`btn btn-sm rounded-pill px-3 py-2 fs-13 fw-600 border-0 ${activeHistoryTab === "approval" ? "text-white" : "bg-light text-dark"}`}
                        style={{
                          backgroundColor: activeHistoryTab === "approval" ? "#4F46E5" : undefined,
                          transition: "all 0.25s ease",
                        }}
                        onClick={() => setActiveHistoryTab("approval")}
                      >
                        Approval History ({approvalHistory?.length || 0})
                      </button>
                    )}
                  </div>
                  <div
                    style={{
                      height: "360px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      paddingRight: "8px",
                    }}
                    className="scroll-container"
                  >
                    {activeHistoryTab === "paid" && (
                      <div className="d-flex flex-column ms-3">
                        {paidHistory.map((txn, idx) => (
                          <div key={idx} className="d-flex mb-4 position-relative">
                            {/* Green tick */}
                            <div
                              className="d-flex align-items-center justify-content-center rounded-circle"
                              style={{
                                backgroundColor: "#E6FFF1",
                                width: "40px",
                                height: "40px",
                                marginRight: "15px",
                                marginLeft: "-19px",
                                zIndex: "1",
                              }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                  backgroundColor: "#4EBD7E",
                                  width: "20px",
                                  height: "20px",
                                  color: "white",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                ✓
                              </div>
                            </div>

                            {/* Vertical dashed line */}
                            {idx !== paidHistory.length - 1 && (
                              <div
                                className="position-absolute start-0"
                                style={{
                                  borderLeft: "2px dashed #3469E7",
                                  height: "calc(100% + 16px)",
                                  left: "8px",
                                  top: "10px",
                                }}
                              />
                            )}

                            {/* Transaction details */}
                            <div className="flex-grow-1">
                              <div className="d-flex align-items-center mb-2">
                                <span className="fw-700 fs-16 me-2" style={{ color: "#2C8C53" }}>
                                  +<span dangerouslySetInnerHTML={{ __html: transactionDetails.currency_symbol || "&#8377;" }} /> {numberFormat(txn.amount ?? "0")}
                                </span>
                                <div className="backgroundGreyDot me-2" style={{ width: "4px", height: "4px" }}></div>
                                <span className="badge rounded-pill fs-11 fw-600" style={{ backgroundColor: "#4F46E5" }}>
                                  {txn.payment_type ?? "-"}
                                </span>
                                <img
                                  src={deleteLogo}
                                  alt="delete"
                                  style={{ marginLeft: "8px", cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setHistoryDeleteId(txn.id);
                                  }}
                                />
                              </div>
                              {txn.remarks && (
                                <p className="m-0 fs-14 fw-500 mb-2" style={{ color: "#1F2937", lineHeight: "1.4" }}>
                                  {txn.remarks}
                                </p>
                              )}
                              <small className="cardTextGrey d-block mb-2 fs-12 fw-400">
                                {txn.date ?? "-"} by {txn.user ?? "-"}
                              </small>
                              <small className="cardTextGrey d-block mb-2 fs-12 fw-400">Payment Date : {txn.payment_date ?? "-"}</small>
                              {txn.file && (
                                <div className="mt-2">
                                  <span
                                    className="px-3 py-1 bg-light fs-11 fw-400 rounded-pill gap-2 d-inline-flex align-items-center"
                                    style={{
                                      maxWidth: "fit-content",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.nativeEvent.stopImmediatePropagation(); // 🔥 THIS is the key

                                      e.stopPropagation();

                                      openFile(txn.file);
                                    }}
                                  >
                                    <img src={attachmentIC} alt="" style={{ width: "20px", flexShrink: 0 }} />

                                    <span
                                      className="fs-12 fw-500"
                                      title={txn.file_name ?? "-"}
                                      style={{
                                        maxWidth: "100px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "inline-block",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {txn.file_name ?? "-"}
                                    </span>

                                    <span
                                      className="fs-12 fw-500"
                                      style={{
                                        whiteSpace: "nowrap",
                                        flexShrink: 0,
                                      }}
                                    >
                                      {Math.round(txn.file_size) ?? 0} Kb
                                    </span>

                                    <img src={downloadIc} alt="" style={{ width: "15px", flexShrink: 0 }} className="cursor-pointer" onClick={() => downloadFile(txn.file, txn.file.split("/").pop())} />
                                  </span>
                                </div>
                              )}
                              {txn.bank_transaction_id && (txn.reconciliation_status === "VALIDATED" || txn.bank_trans_validate == 1 || txn.bank_trans_validate == true || txn.bank_trans_validate === "1" || txn.bank_trans_validate === "true") && (
                                <div className="mt-3 p-3 rounded-4" style={{ backgroundColor: "#F8F9FA", border: "1px solid #EBEBEB", maxWidth: "340px" }}>
                                  <div className="d-flex align-items-center gap-2 mb-2">
                                    <div className="d-flex align-items-center justify-content-center rounded-circle" style={{ backgroundColor: "#EBEBEB", width: "24px", height: "24px" }}>
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: "#4B5563" }}>
                                        <path d="M4 22V12H6V22H4ZM10 22V12H12V22H10ZM18 22V12H20V22H18ZM2 22H22V24H2V22ZM12 2L2 7V10H22V7L12 2ZM4 8L12 4.4L20 8H4Z" fill="currentColor"/>
                                      </svg>
                                    </div>
                                    <span className="fs-12 fw-600" style={{ color: "#8790A1" }}>Bank Transaction Info</span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="fs-14 fw-700" style={{ color: "#4F46E5" }}>
                                      <span dangerouslySetInnerHTML={{ __html: transactionDetails.currency_symbol || "&#8377;" }} /> {txn.bank_amount ?? "0"}
                                    </span>
                                    <span className="fs-12 textGrey d-flex align-items-center gap-1">
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: "#8790A1" }}>
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                      </svg>
                                      {txn.bank_date ?? "-"}
                                    </span>
                                  </div>
                                  <div className="fs-12 textGrey text-wrap" style={{ wordBreak: "break-all", lineHeight: "1.4" }}>
                                    {txn.bank_desc ?? "-"}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {/* ========== Edit History Tab ========== */}
                    {activeHistoryTab === "edit" && (
                      <div className="w-100">
                        {isEditHistoryLoading ? (
                          <div className="d-flex justify-content-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : editHistory.length === 0 ? (
                          <p className="text-center cardTextGrey fs-13 fw-400 py-4">No edit history available</p>
                        ) : (
                          editHistory.map((group, groupIdx) => (
                            <div key={groupIdx} className="mb-4">
                              {/* Date Badge with horizontal line */}
                              <div className="d-flex align-items-center justify-content-center mb-4">
                                <div className="flex-grow-1" style={{ height: "1px", backgroundColor: "#EBEBEB" }}></div>
                                <span
                                  className="px-3 py-1 rounded-pill fs-12 fw-500 mx-2"
                                  style={{
                                    border: "1px solid #EBEBEB",
                                    color: "#212129",
                                    backgroundColor: "#FFFFFF",
                                  }}
                                >
                                  {group.date}
                                </span>
                                <div className="flex-grow-1" style={{ height: "1px", backgroundColor: "#EBEBEB" }}></div>
                              </div>

                              {/* Timeline entries */}
                              {group.histories?.map((entry, idx) => {
                                let isMultiItem = false;
                                let items = [];
                                let singleDescription = entry.description;

                                if (entry.description && entry.description.includes(";")) {
                                  let contentStr = entry.description;
                                  const dashIdx = contentStr.indexOf(" - ");
                                  const semiIdx = contentStr.indexOf(";");
                                  if (dashIdx !== -1 && (semiIdx === -1 || dashIdx < semiIdx)) {
                                    contentStr = contentStr.substring(dashIdx + 3);
                                  }

                                  isMultiItem = true;
                                  items = contentStr
                                    .split(";")
                                    .map((s) => s.trim())
                                    .filter((s) => s !== "")
                                    .map((s) => {
                                      const colonIndex = s.indexOf(":");
                                      if (colonIndex === -1) return { key: s, value: "" };
                                      const key = s.slice(0, colonIndex).trim();
                                      const value = s.slice(colonIndex + 1).trim();
                                      return { key, value };
                                    })
                                    .filter(Boolean);
                                }

                                return (
                                  <div
                                    key={idx}
                                    style={{
                                      display: "flex",
                                      marginTop: idx === 0 ? "12px" : "0px",
                                    }}
                                  >
                                    <div style={{ paddingTop: "2px", gap: "3px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                      <div style={{ width: "32px", height: "32px", flexShrink: 0 }}>
                                        <div
                                          style={{
                                            width: "31.33px",
                                            height: "31.33px",
                                            top: "0.34px",
                                            left: "0.34px",
                                            borderRadius: "100px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                          className="bg-light"
                                        >
                                          <img src={editIcon} style={{ margin: "0", width: "16px", height: "16px" }} alt="status" />
                                        </div>
                                      </div>
                                      {idx !== group.histories.length - 1 && (
                                        <div
                                          style={{
                                            flexGrow: 1,
                                            borderLeft: "1px dashed #E2E8F0",
                                          }}
                                        ></div>
                                      )}
                                    </div>

                                    <div
                                      style={{
                                        gap: "24px",
                                        width: "80%",
                                        marginLeft: "16px",
                                        paddingBottom: "24px",
                                      }}
                                    >
                                      <div>
                                        <span
                                          style={{
                                            fontWeight: "500",
                                            fontSize: "14px",
                                            lineHeight: "18.9px",
                                            color: "#212129",
                                          }}
                                        >
                                          {entry.type ?? ""}
                                        </span>
                                        <span
                                          style={{
                                            fontWeight: "400",
                                            fontSize: "13px",
                                            lineHeight: "18.9px",
                                            color: "#212129",
                                          }}
                                        >
                                          {" "}
                                          ( by {entry.created_by ?? ""} )
                                        </span>
                                      </div>
                                      <div>
                                        <span
                                          style={{
                                            fontWeight: "400",
                                            fontSize: "12px",
                                            lineHeight: "16.2px",
                                            color: "#8790A1",
                                          }}
                                        >
                                          {entry.time ?? "-"}
                                        </span>
                                      </div>
                                      <div className="mt-1">
                                        {isMultiItem ? (
                                          <div className="d-flex flex-column position-relative" style={{ marginTop: "16px", gap: "12px", paddingLeft: "16px" }}>
                                            {items.map((item, pIdx) => (
                                              <div key={pIdx} className="position-relative w-100">
                                                {/* Curve line to the item */}
                                                <div
                                                  className="position-absolute"
                                                  style={{
                                                    left: "-16px",
                                                    top: pIdx === 0 ? "-20px" : "-12px",
                                                    height: pIdx === 0 ? "calc(50% + 20px)" : "calc(50% + 12px)",
                                                    width: "16px",
                                                    borderBottom: "1px solid #E2E8F0",
                                                    borderLeft: "1px solid #E2E8F0",
                                                    borderBottomLeftRadius: "8px",
                                                  }}
                                                />
                                                {/* Vertical line continuing downwards if not last item */}
                                                {pIdx !== items.length - 1 && (
                                                  <div
                                                    className="position-absolute"
                                                    style={{
                                                      left: "-16px",
                                                      top: "50%",
                                                      bottom: "-12px",
                                                      borderLeft: "1px solid #E2E8F0",
                                                    }}
                                                  />
                                                )}

                                                {/* Main Box */}
                                                <div
                                                  className="p-3 bg-light w-100"
                                                  style={{
                                                    backgroundColor: "#E2E8F0",
                                                    border: "1px dashed #E2E8F0",
                                                    borderRadius: "8px",
                                                  }}
                                                >
                                                  <div style={{ fontSize: "13px", color: "#000000ff", fontWeight: "600", marginBottom: "4px" }}>{item.key}</div>
                                                  <div style={{ fontSize: "13px", color: "#334155" }}>
                                                    {(() => {
                                                      const arrowMatch = item.value.match(/->|→|&rarr;/);
                                                      if (arrowMatch) {
                                                        const parts = item.value.split(arrowMatch[0]);
                                                        if (parts.length === 2) {
                                                          return (
                                                            <>
                                                              <span style={{ fontWeight: "400", wordBreak: "break-all" }}>{parts[0].trim()}</span>
                                                              <span style={{ color: "#000000ff", margin: "0 6px", fontWeight: "600" }}>&#8594;</span>
                                                              <span style={{ fontWeight: "600", wordBreak: "break-all" }}>{parts[1].trim()}</span>
                                                            </>
                                                          );
                                                        }
                                                      }
                                                      return <span style={{ wordBreak: "break-all" }}>{item.value}</span>;
                                                    })()}
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <span
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "13px",
                                              lineHeight: "17.55px",
                                              color: "#212129",
                                            }}
                                          >
                                            {singleDescription}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                    {/* ========== Approval History Tab ========== */}
                    {activeHistoryTab === "approval" && (
                      <div className="w-100">
                        <div className="position-relative ps-1">
                          {approvalHistory && approvalHistory.length > 0 ? (
                            approvalHistory.map((h, idx) => {
                              let icon = tickGreen;
                              let bgLabelColor = "#E6FFF1";
                              let textLabelColor = "#10B981";

                              if (h.status === "Rejected") {
                                icon = wrongRed;
                                bgLabelColor = "#FEE2E2";
                                textLabelColor = "#EF4444";
                              } else if (h.status === "Requested") {
                                icon = requestImg;
                                bgLabelColor = "#DBEAFE";
                                textLabelColor = "#2563EB";
                              } else if (h.status === "Created") {
                                icon = createdImg;
                                bgLabelColor = "#F3F4F6";
                                textLabelColor = "#4B5563";
                              } else if (h.status === "Waiting for approval...") {
                                icon = tickGreen;
                                bgLabelColor = "#F3F4F6";
                                textLabelColor = "#4B5563";
                              }

                              return (
                                <div key={idx} className="d-flex align-items-start position-relative mb-4" style={{ zIndex: 1 }}>
                                  {/* Vertical Dashed Line */}
                                  {idx !== approvalHistory.length - 1 && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        left: "16px",
                                        top: "22px",
                                        height: "calc(100% + 24px)",
                                        width: "2px",
                                        borderLeft: "2px dashed #D1D5DB",
                                        zIndex: 0,
                                      }}
                                    ></div>
                                  )}

                                  <div className="me-3" style={{ zIndex: 2, marginTop: "6px" }}>
                                    <img src={icon} alt={h.status} style={{ width: "32px", height: "32px" }} />
                                  </div>
                                  <div className="d-flex flex-column gap-1">
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="fw-600" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "14px", color: "#1F2937" }}>
                                        {h.status}
                                      </span>
                                      <span style={{ color: "#9CA3AF" }}>·</span>
                                      <span
                                        style={{
                                          fontFamily: "'Lexend Deca', sans-serif",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                          backgroundColor: bgLabelColor,
                                          color: textLabelColor,
                                          padding: "2px 8px",
                                          borderRadius: "4px"
                                        }}
                                      >
                                        {h.user_name}
                                      </span>
                                    </div>
                                    {h.comments && (
                                      <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "13px", color: "#4B5563" }}>
                                        {h.comments}
                                      </span>
                                    )}
                                    <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", color: "#9CA3AF" }}>
                                      {h.date_time}
                                    </span>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="text-center py-4 text-muted">No approval history found.</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-12 mt-3 mx-2">
                <div className="row bg-white rounded-4 p-2">
                  <div className="col-xl-12">
                    <p className="fs-18 fw-600 mb-0">Product </p>
                  </div>
                  <div style={{ overflowY: "visible" }}>
                    <div className="mt-2 sticky-table-wrapper ">
                      <table
                        className="sticky-table"
                        border="1"
                        cellPadding="10"
                        style={{
                          borderCollapse: "collapse",
                          width: "100%",
                        }}
                      >
                        <thead
                          style={{
                            height: "48px",
                            backgroundColor: "#F2F2F2", // ✅ Green background
                            color: "#212129", // ✅ White text
                            fontSize: "13px", // ✅ Font size
                            fontWeight: "700",
                            textAlign: "left",
                          }}
                        >
                          <tr>
                            <th className="ps-2">Product Name</th>
                            <th className="ps-2">Product ID</th>
                            {transactionDetails.trans_type === "Purchase-Order" && <th className="ps-2">Total Qty</th>}
                            {transactionDetails.trans_type === "Purchase-Order" && <th className="ps-2">Balance Qty</th>}

                            <th className="ps-2">{transactionDetails.trans_type === "Purchase-Order" ? "Received Qty" : "Quantity"}</th>

                            <th className="ps-2">Amount</th>

                            {isCgst && <th className="ps-2">CGST(%)</th>}
                            {isIgst && <th className="ps-2">IGST(%)</th>}
                            {isSgst && <th className="ps-2">SGST(%)</th>}
                            {<th className="ps-2">Total Amount</th>}
                            {<th className="ps-2">TDS(%)</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {transactionDetails.products?.map((row, index) => (
                            <tr key={row.id} style={{ height: "60px" }}>
                              <td className="px-2 py-1">
                                <div
                                  className="px-1 d-flex align-items-center"
                                  /* style={{
                                    minWidth: "134px",
                                    height: "36px",
                                    borderRadius: "8px",
                                    background: "#F8F8F8",
                                    border: "1px solid #EBEBEB",
                                  }} */
                                >
                                  {row.name}
                                </div>
                              </td>
                              <td className="px-2 py-1">
                                <div className="px-1 d-flex align-items-center">{row.code}</div>
                              </td>
                              {transactionDetails.trans_type === "Purchase-Order" && (
                                <td className="px-2 py-1">
                                  <div className="mx-2 px-1 d-flex align-items-center">{row.total_quantity}</div>
                                </td>
                              )}
                              {transactionDetails.trans_type === "Purchase-Order" && (
                                <td className="px-2 py-1">
                                  <div className="mx-2  px-1 d-flex align-items-center">{row.balance_quantity}</div>
                                </td>
                              )}
                              <td>
                                <div className="mx-2 px-1 d-flex align-items-center">{row.quantity}</div>
                              </td>

                              <td>
                                <div className="mx-2 px-1 d-flex align-items-center">{numberFormat(row.unit_amount)}</div>
                              </td>

                              {isCgst && (
                                <td>
                                  <div className="mx-2 px-1 d-flex align-items-center">{row.cgst_percentage ?? 0}</div>
                                </td>
                              )}

                              {isIgst && (
                                <td>
                                  <div className="mx-2 px-1 d-flex align-items-center">{row.igst_percentage ?? 0}</div>
                                </td>
                              )}

                              {isSgst && (
                                <td>
                                  <div className="mx-2 px-1 d-flex align-items-center">{row.sgst_percentage ?? 0}</div>
                                </td>
                              )}

                              {
                                <td>
                                  <div className="mx-2 px-1 d-flex align-items-center">{numberFormat(row.total_amount ?? 0)}</div>
                                </td>
                              }

                              {
                                <td>
                                  <div className="mx-2 px-1 d-flex align-items-center">{row.tds_percentage ?? 0}</div>
                                </td>
                              }
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <AmountSummary subTotal={summary.subTotal} cgst={summary.cgstTotal} sgst={summary.sgstTotal} igst={summary.igstTotal} roundOff={summary.roundDiff} showRoundOff={summary.roundDiff !== 0} currencySymbol={transactionDetails.currency_symbol ? new DOMParser().parseFromString(transactionDetails.currency_symbol, "text/html").documentElement.textContent : "₹"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
